import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { useGetInfoApi } from '@/api/notice';
import defaultImg from '@/assets/img/defaultImg.jpg';
import InputSearch from '@/components/common/Input/InputSearch/InputSearch';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import TablePagination from '@/components/common/Pagination/TablePagination';
import PostList from '@/components/common/PostList/PostList.tsx';
import BoardTable from '@/components/common/Table/BoardTable/BoardTable';
import { tableOptions } from '@/constants/option';
import { generateColumns } from '@/constants/table';
import useDebounce from '@/hooks/useDebounce';
import useIsMobile from '@/hooks/useIsMobile';
import { useModalStore } from '@/store/modalStore';
import { useTokenStore } from '@/store/tokenStore';
import { convertInfoValue } from '@/utils/convertValue';

import * as S from './style';

const InformationCommunity = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile(600);
	const location = useLocation();
	const { isLogin } = useTokenStore();
	const { showModal } = useModalStore();

	const params = location.state?.menu ?? '자유게시판';
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [selectedOption, setSelectedOption] = useState('전체');
	const debouncedSearch = useDebounce(search, 300);

	const { data: infoData } = useGetInfoApi({
		page: page,
		search: debouncedSearch,
		search_category: selectedOption,
		type: convertInfoValue(params),
	});

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	};
	const handleGetPk = (pk: number | string) => {
		if (!isLogin()) {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}

		navigate(`/information/community/${pk}`, { state: { menu: params } });
	};

	const getDynamicField = (g: any, field: string) => {
		const type = convertInfoValue(params);

		return g[`${type}_${field}`] || '';
	};

	const navigateToSave = () => {
		if (!isLogin()) {
			showModal('로그인이 필요합니다.', 'login', '로그인 하러가기', () => navigate('/auth/login'));
			return;
		}

		navigate(`/information`, { state: { menu: params, step: '등록' } });
	};

	const convertData = () =>
		infoData?.[convertInfoValue(params)]?.map((item) => {
			let nameToUse = item.admin_name;
			if ('member_name' in item) {
				nameToUse = item.admin_name ?? item.member_name;
			}

			return {
				...item,
				admin_name: nameToUse,
			};
		});

	useEffect(() => {
		console.log(`infoData : `, infoData);
		console.log(`convertData() : `, convertData());
	}, []);

	return (
		<S.ConferenceContainer>
			<S.ConferenceBoardBox>
				<S.ConferenceToolBar className={isMobile ? 'mobile' : ''}>
					{!isMobile && (
						<S.Button className="mobile" onClick={navigateToSave}>
							글쓰기
						</S.Button>
					)}
					<S.ConferenceSearchBox>
						<InputSelect options={tableOptions} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
						<InputSearch value={search} input={handleSearch} placeholder="검색어 입력" />
					</S.ConferenceSearchBox>
				</S.ConferenceToolBar>

				{infoData && infoData[convertInfoValue(params)]?.length !== 0 ? (
					params !== '갤러리' ? (
						!isMobile ? (
							<TablePagination activePage={page} totalItems={infoData?.[`${convertInfoValue(params)}_count`] ?? 0} onChange={(page) => setPage(page)}>
								<BoardTable
									columns={generateColumns(infoData[convertInfoValue(params)] ?? [])}
									page={page}
									data={convertData() ?? []}
									totalItems={infoData?.[`${convertInfoValue(params)}_count`] ?? 0}
									onClick={handleGetPk}
								/>
							</TablePagination>
						) : (
							<TablePagination activePage={page} totalItems={infoData?.[`${convertInfoValue(params)}_count`] ?? 0} onChange={(page) => setPage(page)}>
								<PostList data={infoData[convertInfoValue(params)] ?? []} sort={convertInfoValue(params)} />
							</TablePagination>
						)
					) : (
						<TablePagination activePage={page} totalItems={infoData?.gallery_count} onChange={(page) => setPage(page)}>
							<S.ConferenceGalleryBox>
								{infoData &&
									(infoData[convertInfoValue(params)] ?? []).map((g, index) => (
										<S.GalleryItemBox key={index} onClick={() => navigate(`/information/community/${getDynamicField(g, 'pk')}`, { state: { menu: params } })}>
											<div className="img_box">
												<img src={getDynamicField(g, 'image_url') || defaultImg} alt="기본 이미지" />
											</div>
											<S.ContentBox>
												<p className="title">{getDynamicField(g, 'title')}</p>
												<p className="date">{dayjs(getDynamicField(g, 'enrollment_date')).format('YYYY-MM-DD')}</p>
											</S.ContentBox>
										</S.GalleryItemBox>
									))}
							</S.ConferenceGalleryBox>
						</TablePagination>
					)
				) : (
					<S.NoData>등록 내역이 없습니다.</S.NoData>
				)}
				{isMobile && (
					<S.ButtonBox>
						<S.Button className="desktop" onClick={navigateToSave}>
							글쓰기
						</S.Button>
					</S.ButtonBox>
				)}
			</S.ConferenceBoardBox>
		</S.ConferenceContainer>
	);
};

export default InformationCommunity;
